import * as Dom from "./dom";
import * as Display from "./display";
import * as Data from "./data";
import { Course, Shift, Vehicle } from "./entities";

Dom.dialogs.vehicleView.close.onclick = async () => {
  Display.removeVehicleView();
};

Dom.dialogs.vehicleView.self.onclose = async () => {
  Display.resetDarkenedElement();
};

Dom.dialogs.faqView.close.onclick = async () => {
  Display.removeFaqView();
};

Dom.dialogs.faqView.self.onclose = async () => {
  Display.resetDarkenedElement();
};

export async function resetFiltersClicked() {
  Display.clearFilters();
}

export async function filterInputsChanged() {
  Display.applyFilters();
}

export async function vehicleDialogOpened(vehicle: Vehicle) {
  console.info("[Vehicle] Dialog opened");

  // Skip loading additional data for imported vehicles
  if (vehicle.isImported) {
    console.info("[Vehicle] Skipping additional data loading for imported vehicle");
    return;
  }

  // Skip if no connectionId is available
  if (!vehicle.connectionId) {
    console.info("[Vehicle] No connectionId available, skipping trip data loading");
    return;
  }

  const tripId = Math.abs(vehicle.connectionId);

  let coursePromise = Data.fleetoraClient.getCourse(vehicle.id);
  let shiftPromise = Data.fleetoraClient.getShift(vehicle.id);
  let tripPromise = Data.fleetoraClient.getTrip(tripId);

  let course: Course = null;
  let shift: Shift = null;

  try {
    course = await coursePromise;
  } catch (err) {
    console.error("[Vehicle] Failed to load order", err);
  }

  try {
    shift = await shiftPromise;
  } catch (err) {
    console.error("[Vehicle] Failed to load shift", err);
  }

  Display.addVehicleCourse(course, shift);
  Display.addVehicleViewShift(shift);

  try {
    let trip = await tripPromise;

    Display.addVehicleViewTrip(vehicle.lastStopName, trip);
  } catch (err) {
    Display.addVehicleViewTrip(vehicle.lastStopName, null);

    console.error("[Vehicle] Failed to load trip", err);
  }
}

let dialogs = Array.from(document.querySelectorAll<HTMLDialogElement>("dialog"));
for (let dialog of dialogs) {
  dialog.onclick = async (evt: MouseEvent) => {
    let element = evt.target as HTMLDialogElement;
    if (element.nodeName == "DIALOG") element.close();
  };

  dialog.addEventListener("close", () => {
    Display.updateDialogScrollLock();
  });
}
